var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 267,
    viewBox: "0 0 301 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3690_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.062 65.8918C268.062 102.254 238.583 131.733 202.228 131.733C195.572 131.733 189.152 130.747 183.1 128.913L165.262 107.909L136.961 74.5867C136.674 72.4295 136.49 70.2355 136.423 68.0195C136.401 67.3127 136.386 66.6059 136.386 65.8918C136.386 63.2929 136.534 60.7234 136.836 58.2055C138.08 47.4639 141.916 37.5026 147.702 28.9771C149.086 26.9377 150.588 24.972 152.193 23.1019C164.268 8.99572 182.202 0.0578613 202.228 0.0578613C234.563 0.0578613 261.458 23.3743 267.009 54.1121C267.701 57.9331 268.062 61.8719 268.062 65.8918Z",
    fill: "#FFF8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.328 104.647C168.059 69.8673 197.148 42.5016 232.627 42.5016C269.91 42.5016 300.132 72.7239 300.132 110.007C300.132 126.94 295.258 138.808 287.012 150.006",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.255 209.752C279.039 219.565 280.386 230.108 277.552 240.106L247.447 204.664H247.396L247.418 204.627L225.102 178.351C226.045 176.901 227.466 175.76 229.225 175.185L236.536 172.778C244.458 167.639 246.416 155.395 254.257 148.895C265.058 139.949 279.738 142.953 286.254 153.231C288.389 156.596 289.648 160.741 289.611 165.497C289.456 184.97 269.49 194.762 275.255 209.752Z",
    fill: "#DAD6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.041 162.559L247.418 204.627",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.862 188.909L269.033 185.132",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.639 191.994L247.27 179.861",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.07 173.897L259.448 162.559",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.062 201.719L247.447 204.664",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.453 57.8819C142.203 58.4414 141.945 59.001 141.672 59.5531",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.156 62.3949C139.324 63.8453 138.448 65.2147 137.564 66.4663",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.622 67.7621C136.239 68.2701 135.856 68.7487 135.481 69.2051",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0557 196.22C20.7171 195.712 20.3857 195.196 20.0544 194.681",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1181 191.559C7.16295 173.279 0.868164 151.884 0.868164 129.016C0.868164 61.71 55.4303 7.14783 122.744 7.14783C145.611 7.14783 152.9 16.7925 152.738 28.7047",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65 30.5306C152.606 31.1343 152.539 31.7454 152.466 32.3564",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9717 94.3621C51.4473 94.3621 63.9927 81.8167 63.9927 66.3411C63.9927 50.8656 51.4473 38.3201 35.9717 38.3201C20.4961 38.3201 7.95068 50.8656 7.95068 66.3411C7.95068 81.8167 20.4961 94.3621 35.9717 94.3621Z",
    fill: "#FFF8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7392 237.176C55.1213 233.871 33.6601 212.542 25.348 201.859C25.3259 201.837 25.3038 201.815 25.2891 201.786C22.4767 198.156 21.1883 195.778 21.1883 195.778C21.3356 195.535 21.4828 195.285 21.63 195.035C21.7773 194.784 21.9172 194.527 22.0571 194.262C22.1969 193.996 22.3368 193.731 22.4693 193.459C22.6019 193.187 22.7344 192.907 22.8596 192.627C22.9847 192.347 23.1099 192.06 23.2277 191.773C23.316 191.552 23.4044 191.324 23.4927 191.096C23.559 190.926 23.6252 190.757 23.6841 190.58C23.7578 190.374 23.8314 190.168 23.8976 189.955C23.986 189.689 24.0743 189.424 24.1553 189.152C24.2658 188.777 24.3688 188.394 24.4719 188.004C24.5455 187.724 24.6118 187.437 24.678 187.142C24.7517 186.803 24.8179 186.457 24.8842 186.104C24.921 185.905 24.9578 185.706 24.9873 185.5C25.0314 185.257 25.0682 185.014 25.0977 184.771C25.1419 184.492 25.1787 184.212 25.2081 183.925C25.2449 183.579 25.2744 183.225 25.3038 182.872C25.3186 182.688 25.3333 182.497 25.3407 182.305C25.3554 182.106 25.3701 181.9 25.3701 181.694C25.5615 177.299 24.9063 172.233 22.9921 166.417C15.8359 144.654 19.9662 124.356 38.2763 118.871C55.5851 113.688 73.0117 122.597 79.5715 146.914C84.4233 164.878 88.9806 170.768 95.7392 174.464V237.147",
    fill: "#F9F8F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5969 200.924C24.8252 201.211 25.0534 201.499 25.289 201.786C25.3037 201.815 25.3258 201.837 25.3479 201.859C36.4282 215.524 52.3087 227.296 74.9699 233.407C81.3383 235.13 88.2516 236.403 95.7391 237.147",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73975 206.373C9.73975 206.373 32.747 196.087 22.9846 166.417",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1746 139.523L74.9699 233.414",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0947 214.905L91.2259 202.213",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3854 206.372L35.9717 200.851",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8489 169.995L66.3856 151.692",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9406 160.844L35.9717 157.465",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.942 56.9097L120.381 55.0691C119.674 52.6543 113.586 52.3156 106.783 54.3108C99.98 56.2986 95.0325 59.8694 95.7393 62.2842V66.3556C89.1426 64.272 83.5546 59.2362 81.0367 52.2199C80.6612 51.1818 80.3741 50.1364 80.1606 49.0836C80.109 48.8627 80.0649 48.6492 80.0281 48.4283C80.006 48.3326 79.9913 48.2295 79.9839 48.1338C79.9397 47.9056 79.9029 47.6774 79.8808 47.4565C79.8366 47.162 79.7998 46.8675 79.7777 46.5804C79.7557 46.3595 79.7336 46.1386 79.7262 45.9178C79.7115 45.7484 79.7041 45.5865 79.6968 45.4245C79.2845 35.6473 85.1964 26.3266 94.8852 22.8442C97.705 21.8282 100.598 21.4012 103.418 21.5043C103.617 21.5117 103.823 21.519 104.022 21.5337C104.095 21.5337 104.169 21.5337 104.243 21.5485C104.39 21.5485 104.545 21.5706 104.692 21.5853C104.905 21.6 105.112 21.6221 105.325 21.6515C105.568 21.6736 105.811 21.7104 106.054 21.7473C106.267 21.7767 106.474 21.8062 106.68 21.8577C106.834 21.8798 106.989 21.9092 107.144 21.9387C107.416 21.9902 107.688 22.0491 107.953 22.1154C108.483 22.2405 109.006 22.3878 109.522 22.5497C109.853 22.6455 110.184 22.7633 110.508 22.8811C110.707 22.9547 110.898 23.0283 111.097 23.1093C111.266 23.1682 111.428 23.2344 111.59 23.3081C111.767 23.3817 111.936 23.4553 112.106 23.5363C112.319 23.6246 112.533 23.7277 112.746 23.8382C112.997 23.9633 113.254 24.0885 113.505 24.2284C114.071 24.5229 114.616 24.8468 115.154 25.2002C115.345 25.3253 115.537 25.4505 115.721 25.583C116.008 25.7744 116.28 25.9732 116.553 26.1794C116.722 26.3119 116.891 26.4444 117.061 26.5843C117.318 26.7757 117.561 26.9892 117.804 27.1954C118.01 27.3868 118.224 27.5782 118.423 27.7696C118.445 27.7844 118.474 27.8064 118.496 27.8359C118.68 28.0126 118.872 28.1967 119.048 28.3807C119.255 28.5869 119.453 28.8004 119.652 29.0212C119.836 29.22 120.02 29.4262 120.19 29.6397C120.403 29.8753 120.602 30.1256 120.786 30.3759C120.97 30.6041 121.147 30.8397 121.316 31.0827C121.456 31.2741 121.588 31.4655 121.714 31.6569C121.92 31.9588 122.118 32.268 122.303 32.5772C122.45 32.8202 122.597 33.0779 122.744 33.3356C122.811 33.4607 122.884 33.5932 122.943 33.7258C123.451 34.6755 123.893 35.662 124.261 36.7001C126.771 43.6943 125.682 51.1082 121.942 56.9097Z",
    fill: "#DBD8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.836 58.2054C133.699 59.7294 130.379 61.2534 126.904 62.748L121.942 56.9097L120.381 55.0691C119.674 52.6542 113.585 52.3156 106.783 54.3108C99.9797 56.2986 95.0323 59.8693 95.739 62.2841V73.9461C81.6844 78.0469 69.1316 80.3807 60.0391 80.7121C51.8375 81.0213 46.4483 79.696 45.3292 76.5744C43.7831 72.2675 50.6669 65.4426 62.7853 58.1539C67.7696 55.1648 73.63 52.0947 80.1604 49.0835C86.6098 46.1165 93.7071 43.2084 101.231 40.5064C108.756 37.8044 116.081 35.5368 122.943 33.7257C132.249 31.274 140.708 29.6617 147.702 28.977C149.477 28.8003 151.163 28.6825 152.738 28.6383C160.866 28.3512 166.189 29.6764 167.301 32.7833C169.34 38.4597 156.743 48.5019 136.836 58.2054Z",
    fill: "#A49DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.323 28.4913C92.323 28.4913 86.5362 31.9589 85.0637 39.4464",
    stroke: "white",
    strokeWidth: 1.65624,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.072 48.7228C77.9959 37.8192 84.1066 26.7168 94.885 22.8443C105.641 18.979 117.392 23.6394 122.744 33.3356",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.231 40.5065C108.756 37.8045 116.081 35.5369 122.943 33.7258C132.249 31.2742 140.708 29.6618 147.702 28.9771C149.477 28.8004 151.163 28.6826 152.738 28.6385C160.866 28.3513 166.189 29.6765 167.301 32.7834C169.34 38.4598 156.743 48.502 136.836 58.2056C133.699 59.7296 130.379 61.2536 126.904 62.7481",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7392 73.9462C81.6845 78.047 69.1317 80.3809 60.0393 80.7122C51.8376 81.0214 46.4484 79.6962 45.3293 76.5746",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.447 204.664L247.396 204.672L247.418 204.627L247.447 204.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7316 266.574V62.2841C95.0249 59.8693 99.9723 56.2986 106.775 54.3107C113.578 52.3156 119.667 52.6542 120.373 55.0691L197.7 146.082",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.619 168.459L111.415 195.554L127.398 203.343L140.602 176.247L124.619 168.459Z",
    fill: "#DBD8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.932 193.981L129.819 188.614L125.438 171.747",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 98.3813L128.127 93.551L125.279 104.974L144.652 109.804L147.5 98.3813Z",
    fill: "#DBD8E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.613 95.6211L135.135 104.529L145.457 99.3758",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.491 222.658C164.772 222.658 168.243 219.187 168.243 214.905C168.243 210.624 164.772 207.153 160.491 207.153C156.209 207.153 152.738 210.624 152.738 214.905C152.738 219.187 156.209 222.658 160.491 222.658Z",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.262 134.972C121.697 134.972 123.672 132.998 123.672 130.562C123.672 128.127 121.697 126.152 119.262 126.152C116.826 126.152 114.852 128.127 114.852 130.562C114.852 132.998 116.826 134.972 119.262 134.972Z",
    stroke: "#010101",
    strokeWidth: 0.82812,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.201 217.165L221.701 214.309L225.588 209.509L227.201 217.165Z",
    fill: "#FFF8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22 204.377L230.389 203.612L219.139 217.46L202.22 204.377Z",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.22 204.377L225.588 209.509L227.201 217.165L223.299 215.163",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.484 83.0019L111.627 80.9405L109.19 79.2545L109.484 83.0019Z",
    fill: "#FFF8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.247 73.7253L106.179 77.193L113.232 82.0448L119.247 73.7253Z",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.247 73.7253L109.19 79.2544L109.484 83.0018L111.008 81.5515",
    stroke: "#110D0F",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.123 246.593C199.04 244.075 189.123 236.16 184.786 223.711C181.054 212.991 181.031 201.27 180.325 190.175C179.677 179.993 175.657 169.141 167.109 162.846C160.653 158.083 152.716 156.139 144.735 156.286C125.394 156.64 93.0222 162.596 83.3555 139.758C79.3136 130.209 84.3789 118.326 89.7534 110.242L93.464 106.48",
    stroke: "#EA5699",
    strokeWidth: 0.82812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3690_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 266.884,
    fill: "white",
    transform: "translate(0.5 0.0578613)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.677b2504fd2e1463520867edb3601a5e.svg";
export { ForwardRef as ReactComponent };